<template>
  <div class="buy-process">
       <div class="top-banner">
        <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/p-step-header.png" class="banner"/>
       </div>
       <div class="process-step">
          <div class="step-container">
            <div :class="step > 0 ? 'step active' : 'step'" @click="step=1">
              <div class="sicon">
                <div class="cicle"></div>
              </div>
              <div class="sname">挑选爱车</div>
            </div>
            <div :class="step > 1 ? 'step active' : 'step'" @click="step=2">
              <div class="sicon">
                <div class="cicle"></div>
              </div>
              <div class="sname">了解爱车</div>
            </div>
            <div :class="step > 2 ? 'step active' : 'step'" @click="step=3">
              <div class="sicon">
                <div class="cicle"></div>
              </div>
              <div class="sname">意向订车</div>
            </div>
            <div :class="step > 3 ? 'step active' : 'step'"  @click="step=4">
              <div class="sicon">
                <div class="cicle"></div>
              </div>
              <div class="sname">过户提车</div>
            </div>
          </div>
       </div>
       <div class="usr-step">
         <img :src="`https://assets.rurushishi.com/yq-rs-make/car/mobile/images/p-step-${step}.png`" class="steps-view"/>
       </div>
     </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  props: {},
  data() {
    return {
      step: 1
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "userInfo"
    ])
  },
  methods: {

  },
  beforeCreate() {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.buy-process{
    width: 100%;
    overflow: hidden;
    .top-banner{
        margin: 0.2rem 0.3rem;
        .banner{
            width: 6.9rem;
            height: 2.4rem;
            border-radius: 10px;
        }
    }
    .process-step{
        margin: 0px 0.3rem;
        border-radius: 10px;
        background-color: #fff;
        .step-container{
            margin: 0px 0.15rem;
            padding: 0.5rem 0px 0.3rem 0px;
            display: flex;
            .step{
                flex: 1;
                display: flex;
                flex-direction: column;
                .sicon{
                    height: 0.3rem;
                    display: flex;
                    justify-content: center;
                    position: relative;
                    &::after{
                        content: "";
                        display: inline-block;
                        height: 0.01rem;
                        background:#eee;
                        width:100%;
                        position: absolute;
                        top: 0.14rem;
                        z-index: 1;
                    }
                    .cicle{
                        width: 0.13rem;
                        height: 0.13rem;
                        background: #FFFFFF;
                        border: 5px solid #888;
                        border-radius: 50%;
                        position: relative;
                        z-index: 2;
                    }
                }
                .sname{
                    display: flex;
                    justify-content: center;
                    padding: 0.15rem 0px;
                    color:#888;
                    font-size: 0.26rem;
                }
            }
            .active{
                .sicon{
                    &::after{
                        background:#0D89FF;
                    }
                    .cicle{
                        border: 5px solid #0D89FF;
                    }
                }
                .sname{
                    color:#0D89FF;
                }
            }
        }
    }
    .usr-step{
      margin: .2rem .3rem;
      .steps-view{
        width: 100%;
        border-radius: 5px;
      }
    }
}
</style>